module.exports = __webpack_public_path__ + "img/ada-badge-2013_cn.da57510.svg";